const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let { getNewDog } = require('./services.blop');

function DogGame(attributes, children) {let dog, input, percent, __10, __13, __16, __21, __27;
  let { page, state } = attributes;
  dog = page.choice;

  input = (() => {const __1c = []; const __1a = {}; __1a['type'] = 'text'; __1a['class'] = 'form-control'; __1a['placeholder'] = 'Breed'; const __1 = blop.h('input', __1a, __1c); return __1;})();

  function check() {let guess;
    guess = input.elm.value.toLowerCase().replace(' ', '-');
    input.elm.value = '';
    page.attempt += 1
    if ((guess === dog.breed)) {
      delete page.lastMistake;
      page.success += 1
    } else {
      page.lastMistake = ({ breed: dog.breed, guess });
    }
    getNewDog(state);
  };

  function hint() {
    input.elm.value = dog.breed.slice(0, 2);
  };

  const __2c = []; const __2a = {};
    const __3c = []; const __3a = {}; const __4 = children; Array.isArray(__4) ? __3c.push(...__4) : __3c.push(__4); const __3 = blop.h('h3', __3a, __3c); __2c.push(__3);

    percent = 0;
    if (page.attempt) {
      percent = Math.floor(100 * (page.success / page.attempt));
    }
    const __5c = []; const __5a = {}; const __6 = `Correct answers: ${page.success} / ${page.attempt} (${percent}%)`; Array.isArray(__6) ? __5c.push(...__6) : __5c.push(__6); const __5 = blop.h('p', __5a, __5c); __2c.push(__5);

    if ((page.lastMistake)) {
      const __7c = []; const __7a = {};
        const __8c = []; const __8a = {}; __8a['style'] = ({ color: 'red' }); const __9 = 'Wrong'; Array.isArray(__9) ? __8c.push(...__9) : __8c.push(__9); const __8 = blop.h('span', __8a, __8c); __7c.push(__8);
        __10 = ' the breed was '; Array.isArray(__10) ? __7c.push(...__10) : __7c.push(__10); ;
        const __11c = []; const __11a = {}; const __12 = page.lastMistake.breed; Array.isArray(__12) ? __11c.push(...__12) : __11c.push(__12); const __11 = blop.h('b', __11a, __11c); __7c.push(__11);
        __13 = ' and you guessed "'; Array.isArray(__13) ? __7c.push(...__13) : __7c.push(__13); ;
        const __14c = []; const __14a = {}; const __15 = page.lastMistake.guess; Array.isArray(__15) ? __14c.push(...__15) : __14c.push(__15); const __14 = blop.h('b', __14a, __14c); __7c.push(__14);
        __16 = '"'; Array.isArray(__16) ? __7c.push(...__16) : __7c.push(__16); ;
       const __7 = blop.h('p', __7a, __7c); __2c.push(__7);
    }

    const __17c = []; const __17a = {}; __17a['on'] = ({ submit: (e) => {
        e.preventDefault();
        check();
      }
    });
      const __18c = []; const __18a = {}; __18a['class'] = 'form-group';
        const __19c = []; const __19a = {}; __19a['for'] = 'exampleInputPassword1'; const __20 = 'Your guess on the breed'; Array.isArray(__20) ? __19c.push(...__20) : __19c.push(__20); const __19 = blop.h('label', __19a, __19c); __18c.push(__19);
        __21 = input; Array.isArray(__21) ? __18c.push(...__21) : __18c.push(__21); ;
       const __18 = blop.h('div', __18a, __18c); __17c.push(__18);
      const __22c = []; const __22a = {}; __22a['type'] = 'button'; __22a['on'] = ({ click: check }); __22a['class'] = 'btn btn-primary'; const __23 = 'Check'; Array.isArray(__23) ? __22c.push(...__23) : __22c.push(__23); const __22 = blop.h('button', __22a, __22c); __17c.push(__22);
      const __24c = []; const __24a = {}; __24a['type'] = 'button'; __24a['on'] = ({ click: hint }); __24a['class'] = 'btn'; const __25 = 'Hint'; Array.isArray(__25) ? __24c.push(...__25) : __24c.push(__25); const __24 = blop.h('button', __24a, __24c); __17c.push(__24);
     const __17 = blop.h('form', __17a, __17c); __2c.push(__17);

    const __26c = []; const __26a = {}; __26a['style'] = ({ minHeight: '400px' });
      __27 = dog ? (() => {const __28c = []; const __28a = {}; __28a['src'] = `https://images.dog.ceo/breeds/${dog.breed}/${dog.image}`; __28a['style'] = ({ maxWidth: '400px' }); const __28 = blop.h('img', __28a, __28c); return __28;})() : (() => {const __29c = []; const __29a = {}; const __30 = 'Loading...'; Array.isArray(__30) ? __29c.push(...__30) : __29c.push(__30); const __29 = blop.h('h3', __29a, __29c); return __29;})(); Array.isArray(__27) ? __26c.push(...__27) : __26c.push(__27); ;
     const __26 = blop.h('div', __26a, __26c); __2c.push(__26);

   const __2 = blop.h('div', __2a, __2c); return __2;
};
module.exports = { getNewDog, DogGame };
